function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffcc00",
      fillOpacity: 1
    },
    d: "M 13.476562 1.164062 L 16.75 7.796875 L 24.066406 8.859375 C 24.960938 8.988281 25.316406 10.089844 24.667969 10.71875 L 19.375 15.878906 L 20.625 23.167969 C 20.777344 24.054688 19.84375 24.734375 19.042969 24.316406 L 12.5 20.875 L 5.957031 24.316406 C 5.15625 24.734375 4.222656 24.054688 4.375 23.167969 L 5.625 15.878906 L 0.332031 10.71875 C -0.316406 10.089844 0.0390625 8.988281 0.933594 8.859375 L 8.25 7.796875 L 11.523438 1.164062 C 11.921875 0.355469 13.078125 0.355469 13.476562 1.164062 Z M 13.476562 1.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffcc00",
      fillOpacity: 1
    },
    d: "M 24.066406 8.859375 L 16.75 7.796875 L 13.476562 1.164062 C 13.269531 0.75 12.867188 0.546875 12.464844 0.558594 L 12.464844 20.894531 L 12.5 20.875 L 19.042969 24.316406 C 19.84375 24.734375 20.777344 24.054688 20.625 23.167969 L 19.375 15.878906 L 24.667969 10.71875 C 25.316406 10.089844 24.960938 8.988281 24.066406 8.859375 Z M 24.066406 8.859375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.2b290280d2735a2682a8eb0e96daba2f.svg";
export { ForwardRef as ReactComponent };